import { Container, Row, Col } from 'react-bootstrap';
import PageHero from '../components/PageHero';

export default function Accommodation() {
  return (
    <>
      <PageHero
        eyebrow="Participant info"
        title="Accommodation"
        intro="Accommodation information for the participants of EAC2027 will be published here as soon as recommended options are confirmed."
      />

      <main className="info-page py-5">
        <Container>
          <Row className="justify-content-center mt-5">
            <Col lg={10} xl={9}>
              <section className="info-section">
                <h2>Recommended accommodation</h2>
                <p className="info-note">Please check this page again later for updates.</p>
              </section>
            </Col>
          </Row>
        </Container>
      </main>

    </>
  );
}
